<template>
	<div>
		<v-select v-if="categoryOptions.length > 0 && !readonly" class="mr-2" v-model="categoryFilter" :items="categoryOptions" item-text="name" item-value="id" label="Filter by Category" no-data-text="No categories have been assigned" clearable />
		<v-data-table :headers="headers" v-model="selected" :items="hrDocumentsSorted" hide-actions item-key="id" disable-initial-sort class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr style="height: 64px" :class="{ 'mandatory-row': props.item.relevantParties.all }">
					<td style="width: 1px">
						<v-checkbox :disabled="props.item.relevantParties.all || readonly" v-model="props.selected" primary hide-details></v-checkbox>
					</td>
					<td class="text-xs-left">
						<router-link v-if="!noLinks" :to="{ name: 'hrDocument', params: { id: props.item.id } }">{{ props.item.name }}</router-link>
						<span v-else>{{ props.item.name }}</span>
					</td>
					<td class="text-xs-left">
						<v-tooltip v-if="props.item.relevantParties.all" bottom>
							<template slot="activator">
								<v-icon small class="mr-2">mdi-lock</v-icon>
								<span>Mandatory for all</span>
							</template>
							<span>This policy is mandatory for all employees</span>
						</v-tooltip>
						<span v-else-if="props.selected">Mandatory</span>
						<span v-else>Optional</span>
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Array,
				required: true
			},
			hrDocuments: {
				type: Array,
				required: true
			},
			employeeId: {
				type: String,
				required: false
			},
			noLinks: {
				type: Boolean,
				default: false
			},
			readonly: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			selected() {
				const customSelected = this.selected.filter(x => !x.relevantParties.all).map(x => x.id);
				this.$emit('input', customSelected);
			}
		},
		data() {
			return {
				selected: [],
				headers: [
					{ text: '', value: 'select', sortable: false },
					{ text: 'Policy Name', value: 'name' },
					{ text: 'Status', value: 'status' }
				],
				categoryFilter: null
			};
		},
		created() {
			let selected;
			if (this.employeeId) {
				selected = this.hrDocuments.filter(x => this.value.includes(x.id) || x.relevantParties.all || x.relevantParties.employeeIds.findIndex(x => x === this.employeeId) > -1);
			} else {
				selected = this.hrDocuments.filter(x => this.value.includes(x.id) || x.relevantParties.all);
			}
			this.selected = [...selected];
		},
		computed: {
			categoryOptions() {
				const unique = [];
				this.hrDocuments.forEach(doc => {
					if (doc.category && doc.category.id && !unique.find(x => x.id === doc.category.id)) {
						unique.push(doc.category);
					}
				});

				return unique.sort((a, b) => a.name.localeCompare(b.name));
			},
			hrDocumentsSorted() {
				let sorted = this.hrDocuments.sort((a, b) => a.relevantParties.all - b.relevantParties.all);

				if (this.categoryFilter) {
					sorted = sorted.filter(x => x.category && x.category.id === this.categoryFilter);
				}

				if (this.readonly) {
					sorted = sorted.filter(x => this.selected.some(s => s.id === x.id));
				}

				return sorted;
			}
		}
	};
</script>

<style scoped>
	.mandatory-row {
		opacity: 0.8;
		background-color: rgba(0, 0, 0, 0.04);
	}
</style>
